export const EXTRA_SYSTEM_COLUMNS = {
  result: {
    key: "result",
    label: "Result",
    width: "110px",
    type: "result",
  },

  failure: {
    key: "failure",
    label: "Failure",
    width: "90px",
    type: "failure",
  },
};

export const PLATFORM_CONFIG = {
  asana: {
    label: "Asana",
    assigneeType: "single",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "150px",
        type: "platform",
        required: true,
      },
      {
        key: "assignee",
        label: "Assignee",
        width: "170px",
        type: "assignee",
        required: false,
      },
      {
        key: "tags",
        label: "Tags",
        width: "180px",
        type: "multiselect",
        required: false,
      },
      {
        key: "date",
        label: "Due On",
        width: "135px",
        type: "date",
        required: false,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  trello: {
    label: "Trello",
    assigneeType: "multi",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "145px",
        type: "platform",
        required: true,
      },
      {
        key: "assignee",
        label: "Assignee",
        width: "160px",
        type: "assignee",
        required: false,
      },
      {
        key: "list",
        label: "List",
        width: "170px",
        type: "dropdown",
        required: true,
      },
      {
        key: "labels",
        label: "Labels",
        width: "170px",
        type: "multiselect",
        required: false,
      },
      {
        key: "date",
        label: "Due On",
        width: "135px",
        type: "date",
        required: false,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  github: {
    label: "GitHub",
    assigneeType: "multi",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "145px",
        type: "platform",
        required: true,
      },
      {
        key: "assignee",
        label: "Assignee",
        width: "160px",
        type: "assignee",
        required: false,
      },
      {
        key: "labels",
        label: "Labels",
        width: "180px",
        type: "multiselect",
        required: false,
      },
      {
        key: "milestone",
        label: "Milestone",
        width: "160px",
        type: "dropdown",
        required: false,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  microsoft_todo: {
    label: "Microsoft To Do",
    assigneeType: "none",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "300px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "170px",
        type: "platform",
        required: true,
      },
      {
        key: "labels",
        label: "Labels",
        width: "180px",
        type: "multiselect",
        required: false,
      },
      {
        key: "date",
        label: "Due On",
        width: "135px",
        type: "date",
        required: false,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  todoist: {
    label: "Todoist",
    assigneeType: "single",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "150px",
        type: "platform",
        required: true,
      },
      {
        key: "assignee",
        label: "Assignee",
        width: "170px",
        type: "assignee",
        required: false,
      },
      {
        key: "labels",
        label: "Labels",
        width: "180px",
        type: "multiselect",
        required: false,
      },
      {
        key: "priority",
        label: "Priority",
        width: "120px",
        type: "dropdown",
        required: false,
      },
      {
        key: "date",
        label: "Due On",
        width: "135px",
        type: "date",
        required: false,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  gmail: {
    label: "Gmail",
    assigneeType: "multi",
    assigneeLabel: "Recipients",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "150px",
        type: "platform",
        required: true,
      },
      {
        key: "assignee",
        label: "Recipients",
        width: "220px",
        type: "assignee",
        required: true,
      },
      {
        key: "permission",
        label: "Permission",
        width: "152px",
        type: "dropdown",
        required: true,
      },
      {
        key: "labels",
        label: "Labels",
        width: "170px",
        type: "multiselect",
        required: false,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  slack: {
    label: "Slack",
    assigneeType: "single",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "150px",
        type: "platform",
        required: true,
      },
      {
        key: "assignee",
        label: "Assignee",
        width: "170px",
        type: "assignee",
        required: true,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  outlook: {
    label: "Outlook",
    assigneeType: "multi",
    assigneeLabel: "Recipients",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "150px",
        type: "platform",
        required: true,
      },
      {
        key: "assignee",
        label: "Recipients",
        width: "220px",
        type: "assignee",
        required: true,
      },
      {
        key: "permission",
        label: "Permission",
        width: "152px",
        type: "dropdown",
        required: true,
      },
      {
        key: "labels",
        label: "Labels",
        width: "170px",
        type: "multiselect",
        required: false,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  google_calendar: {
    label: "Google Calendar",
    assigneeType: "multi",
    assigneeLabel: "Attendees",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "170px",
        type: "platform",
        required: true,
      },
      {
        key: "assignee",
        label: "Attendees",
        width: "210px",
        type: "assignee",
        required: false,
      },
      {
        key: "date",
        label: "Date",
        width: "135px",
        type: "date",
        required: true,
      },
      {
        key: "start_time",
        label: "Start Time",
        width: "130px",
        type: "time",
        required: true,
      },
      {
        key: "duration",
        label: "Duration",
        width: "130px",
        type: "dropdown",
        required: true,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  outlook_calendar: {
    label: "Outlook Calendar",
    assigneeType: "multi",
    assigneeLabel: "Attendees",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "170px",
        type: "platform",
        required: true,
      },
      {
        key: "assignee",
        label: "Attendees",
        width: "210px",
        type: "assignee",
        required: false,
      },
      {
        key: "date",
        label: "Date",
        width: "135px",
        type: "date",
        required: true,
      },
      {
        key: "start_time",
        label: "Start Time",
        width: "130px",
        type: "time",
        required: true,
      },
      {
        key: "duration",
        label: "Duration",
        width: "200px",
        type: "dropdown",
        required: true,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  notion: {
    label: "Notion",
    assigneeType: "multi",
    assigneeLabel: "Recipients",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "150px",
        type: "platform",
        required: true,
      },
      {
        key: "properties",
        label: "Properties",
        width: "220px",
        type: "multiselect",
        required: true,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  jira: {
    label: "Jira",
    assigneeType: "multi",
    assigneeLabel: "Assignee",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "150px",
        type: "platform",
        required: true,
      },
      {
        key: "assignee",
        label: "Assignee",
        width: "220px",
        type: "assignee",
        required: true,
      },
      {
        key: "labels",
        label: "Labels",
        width: "220px",
        type: "labels",
        required: true,
      },
      {
        key: "list",
        label: "Statuses",
        width: "220px",
        type: "list",
        required: true,
      },
      {
        key: "priority",
        label: "Priority",
        width: "220px",
        type: "priority",
        required: true,
      },
      {
        key: "date",
        label: "Date",
        width: "220px",
        type: "multiselect",
        required: true,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  linear: {
    label: "Linear",
    assigneeType: "multi",
    assigneeLabel: "Recipients",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "150px",
        type: "platform",
        required: true,
      },
      {
        key: "assignee",
        label: "Assignee",
        width: "220px",
        type: "multiselect",
        required: true,
      },
      {
        key: "labels",
        label: "Labels",
        width: "170px",
        type: "multiselect",
        required: false,
      },
      {
        key: "priority",
        label: "Priority",
        width: "170px",
        type: "priority",
        required: false,
      },
      {
        key: "list",
        label: "List",
        width: "170px",
        type: "list",
        required: false,
      },
      {
        key: "date",
        label: "Date",
        width: "135px",
        type: "date",
        required: true,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  clickup: {
    label: "ClickUp",
    assigneeType: "multi",
    fields: [
      {
        key: "checkbox",
        label: "",
        width: "3px",
        type: "checkbox",
        required: false,
      },
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "150px",
        type: "platform",
        required: true,
      },
      {
        key: "assignee",
        label: "Assignee",
        width: "170px",
        type: "assignee",
        required: false,
      },
      {
        key: "priority",
        label: "Priority",
        width: "120px",
        type: "dropdown",
        required: false,
      },
      {
        key: "list",
        label: "List",
        width: "120px",
        type: "dropdown",
        required: false,
      },
      {
        key: "date",
        label: "Due On",
        width: "135px",
        type: "date",
        required: false,
      },
      {
        key: "status",
        label: "Status",
        width: "100px",
        type: "status",
        required: false,
      },
      {
        key: "actions",
        label: "Actions",
        width: "95px",
        type: "actions",
        required: false,
      },
    ],
  },

  unknown: {
    label: "Unknown",
    assigneeType: "none",
    fields: [
      {
        key: "task",
        label: "Task",
        width: "200px",
        type: "task",
        required: true,
      },
      {
        key: "platform",
        label: "Platform",
        width: "100px",
        type: "platform",
        required: false,
      },
      {
        key: "status",
        label: "Status",
        width: "110px",
        type: "status",
        required: false,
      },
    ],
  },
};

export const getPlatformColumns = ({
  platformType,
  hasResult = false,
  hasFailure = false,
}) => {
  const config = PLATFORM_CONFIG[platformType] || { fields: [] };

  const columns = [...config.fields];

  const actionIndex = columns.findIndex((col) => col.key === "actions");

  if (hasResult && actionIndex !== -1) {
    columns.splice(actionIndex, 0, EXTRA_SYSTEM_COLUMNS.result);
  }

  if (hasFailure && actionIndex !== -1) {
    const updatedIndex = columns.findIndex((col) => col.key === "actions");

    columns.splice(updatedIndex, 0, EXTRA_SYSTEM_COLUMNS.failure);
  }

  return columns;
};
